import { gql } from '@common/hooks';
import { DetailItemAttachments } from '@onboarding/graphql/fragments';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

const UpdateNurseHealthDoc = gql`
  mutation UpdateNurseHealthDoc(
    $id: ID!
    $input: UpdateNurseHealthDocInput!
    $files: [FileUploadInput!]!
  ) {
    updateNurseHealthDoc(id: $id, input: $input, files: $files) {
      nurseHealthDoc {
        id
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

const CreateNurseHealthDocMutation = gql`
  mutation CreateNurseHealthDocMutation(
    $worksProfileId: ID!
    $worksListItemId: ID!
    $healthDocId: ID!
    $input: CreateNurseHealthDocInput!
    $files: [FileUploadInput!]!
  ) {
    createNurseHealthDoc(
      worksProfileId: $worksProfileId
      worksListItemId: $worksListItemId
      healthDocId: $healthDocId
      input: $input
      files: $files
    ) {
      nurseHealthDoc {
        id
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

export { CreateNurseHealthDocMutation, UpdateNurseHealthDoc };
